export enum ContactPersonType {
  Technical, Financial, Sales
  }
  